import {createAsyncThunk} from '@reduxjs/toolkit'
import {shipmentHistory as shipmentHistoryService} from 'services/flight.service'
import {
    defaultResponse
    // setResponse
} from './trackshipment.slice'
import {getHistoryGrouping, getStatusDescription} from './trackshipment.utils'
import {
    exceptionCarriersMap
    // partialInfoCarrierMapping,
    // nonParticipatingCarrierMapping
} from './trackshipment.constants'
import {get as _get} from 'lodash'

export const getShipmentDetails = createAsyncThunk(
    'getShipmentDetails',
    async (payload: Record<string, string>, {dispatch, rejectWithValue}) => {
        const {carrier, airlineCode, airWayBill, userId} = payload
        // dispatch(setResponse(defaultResponse))
        try {
            const startIndex: number = carrier.indexOf('(')
            const endIndex: number = carrier.indexOf(')')
            const carrierCode = carrier.slice(startIndex + 1, endIndex)

            const request = {
                carrier: carrierCode,
                awbNo: `${airlineCode}${airWayBill}`,
                userId: userId
            }

            // const nonParticipatingCarrierInfo = nonParticipatingCarrierMapping.get(airlineCode)

            // if (nonParticipatingCarrierInfo) {
            //     const result = Object.assign({}, defaultResponse)
            //     result.successFlag = true
            //     result.nonParicipatingCarrier = {...nonParticipatingCarrierInfo, carrier}
            //     result.airlineCode = airlineCode
            //     result.awbNumber = airWayBill

            //     return {
            //         response: result,
            //         formValues: payload,
            //         carrier
            //     }
            // } else {

            // API CALL
            const {data} = await shipmentHistoryService(request)

            // Error part
            if (data?.response?.messages) {
                // eslint-disable-next-line no-unsafe-optional-chaining
                const {code, text} = data?.response?.messages?.messageEntry
                return rejectWithValue({
                    error: {text, code},
                    formValues: payload,
                    carrier
                })
            } else if (
                data?.successFlag &&
                (exceptionCarriersMap.has(airlineCode) || exceptionCarriersMap.has(carrierCode)) &&
                Object.entries(data?.response).length > 0
            ) {
                const exceptionCarrierInfo =
                    exceptionCarriersMap.get(airlineCode) || exceptionCarriersMap.get(carrierCode)

                const result = Object.assign({}, defaultResponse)
                result.exceptionCarrier = {
                    ...exceptionCarrierInfo,
                    carrier: carrierCode,
                    airlineCode
                }
                result.successFlag = true
                result.airlineCode = airlineCode
                result.awbNumber = airWayBill

                const {
                    origin: respOriginStn = '',
                    destination: respDestStn = '',
                    pieces: respPieces = '',
                    weight: respWeight = '',
                    weightUnit: respWeightUnit = ''
                } = data.response

                result.routingInfo = {
                    ...result.routingInfo,
                    originStation: respOriginStn,
                    destinationStation: respDestStn
                }
                result.unitInfo = {
                    ...result.unitInfo,
                    totalPieces: respPieces,
                    totalWeight: respWeight,
                    weightUnit: respWeightUnit
                }

                return {
                    response: result,
                    formValues: payload,
                    carrier
                }
            } else if (data?.successFlag && Object.entries(data?.response).length > 0) {
                let currentStatus = {status: '- -', description: '- -', group: 'document'}
                if (carrierCode === 'AY') {
                    const respAwbNumber = data?.response?.[0]?.DETAIL?.[0]?.['AWB-INFO']?.AWB
                    const history = data?.response?.[0]?.DETAIL?.[0]?.HISTORY || []
                    const historyGrouping: any[] = getHistoryGrouping(history)
                    const {ORIGIN: respOriginStn = '', DEST: respDestStn = ''} =
                        data?.response?.[0]?.DETAIL?.[0]?.['AWB-INFO']?.ROUTING || {}
                    const {PCS: respPieces = '', WGT: respWeight = ''} =
                        data?.response?.[0]?.DETAIL?.[0]?.['AWB-INFO']?.SDCTOTALS || {}
                    const respWeightUnit = data?.response?.[0]?.DETAIL?.[0]?.['AWB-INFO']?.WUNI || ''
                    const date = data?.response?.[0]?.DETAIL?.[0].HISTORY?.[0]?.DATE
                    if (history?.length > 0) {
                        const lastStatus = historyGrouping[0][1]
                        currentStatus = getStatusDescription(lastStatus[lastStatus?.length - 1]?.STATUS)
                    }

                    const result = {
                        successFlag: data?.successFlag,
                        airlineCode: respAwbNumber?.slice(0, 3),
                        awbNumber: respAwbNumber?.slice(3),
                        currentStatus,
                        routingInfo: {originStation: respOriginStn?.STATION, destinationStation: respDestStn?.STATION},
                        unitInfo: {totalPieces: respPieces, totalWeight: respWeight, weightUnit: respWeightUnit},
                        shipmentHistory: historyGrouping,
                        shipmentYear: `${date ? `20${date.slice(-2)}` : ''}`,
                        exceptionCarrier: {}
                    }

                    return {
                        response: result,
                        formValues: payload,
                        carrier
                    }
                }

                const history = data?.response?.DETAIL?.HISTORY || []
                const historyGrouping: any[] = getHistoryGrouping(history)
                // const partialCarrier = partialInfoCarrierMapping.get(airlineCode)
                const {ORIGIN: respOriginStn = '', DEST: respDestStn = ''} =
                    data?.response?.DETAIL['AWB-INFO']?.ROUTING || {}
                let {
                    PCS: respPieces = '',
                    WGT: respWeight = '',
                    WUNI: respWeightUnit = ''
                } = data?.response?.DETAIL['AWB-INFO']?.SDCTOTALS || {}
                const respAwbNumber = data?.response?.DETAIL['AWB-INFO']?.AWB
                const {DATE: respDate} = data?.response?.DETAIL?.['ISSUE-DATETIME'] || {}
                if (history?.length > 0) {
                    const lastStatus = historyGrouping[0][1]
                    currentStatus = getStatusDescription(lastStatus[lastStatus?.length - 1]?.STATUS)
                }

                if (carrierCode === 'QR') {
                    respWeightUnit = _get(data, 'response.DETAIL.HISTORY.WEIGHTUNIT', respWeightUnit)
                }

                const result = {
                    successFlag: data?.successFlag,
                    airlineCode: respAwbNumber?.slice(0, 3),
                    awbNumber: respAwbNumber?.slice(3),
                    currentStatus,
                    routingInfo: {originStation: respOriginStn?.STATION, destinationStation: respDestStn?.STATION},
                    unitInfo: {totalPieces: respPieces, totalWeight: respWeight, weightUnit: respWeightUnit},
                    shipmentHistory: historyGrouping,
                    shipmentYear: `${respDate ? `20${respDate?.slice(5)}` : ''}`,
                    exceptionCarrier: {}
                    // partialCarrier: partialCarrier ? {...partialCarrier, carrier} : {},
                    // nonParicipatingCarrier: {}
                }

                return {
                    response: result,
                    formValues: payload,
                    carrier
                }
            } else if (!data?.successFlag) {
                // eslint-disable-next-line no-unsafe-optional-chaining
                const {code} = data?.errorList[0]
                const msg = 'Unexpected error occurred. Please try again later.'
                return rejectWithValue({
                    error: {text: msg, code},
                    formValues: payload,
                    carrier
                })
            }
            // }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Something Went Wrong',
                    code: '500'
                },
                formValues: payload,
                carrier
            })
            // if (err.status >= 400 && err.status < 500) {
            //     const msg: string =
            //         String(err?.response?.errors[0]?.field) + ' ' + String(err?.response?.errors[0]?.defaultMessage)
            //     return rejectWithValue(msg)
            // } else if (err.status > 500) {
            //     return rejectWithValue('Something went wrong')
            // }
            // return rejectWithValue(err.message)
        }
    }
)
